<template>
    <div class="body-inner">
        <header-landing-component></header-landing-component>


        <div id="slider" class="inspiro-slider dots-creative" data-height-xs="360">
          
          <div class="slide kenburns" style="background-image:url('../../assets/images/pmi/pmi_bg.jpg');">
              <div class="bg-overlay"></div>
              <div class="container">
                  <div class="slide-captions text-center text-light">
                      <!-- Captions -->
                      <span class="strong">Certificaciones</span>
                      <h1>PMI Project Management Ready<br>
</h1>
                      <!-- end: Captions -->
                  </div>
              </div>
          </div>
          

      </div>



        <section>
            <div class="container">
                <div class="row">
                    <div class="col-lg-4">
                        <div class="heading-text heading-section">
                            <h2 style="font-size: 2.85rem">LA HABILIDAD <br>
MÁS SOLICITADA</h2>

                        </div>
						<img src="../../assets/images/certificaciones/pmi.png">
                    </div>
                    <div class="col-lg-8">
                        <div class="row">
                            <div class="col-lg-10">
								<h4>Dé el primer paso hacia una carrera profesional en Gestión de Proyectos</h4>
								El Project Management Institute® ( PMI ) es la asociación líder mundial para quienes consideran seguir una profesión en la gestión de proyectos, programas o porfolios. La certificación PMI Project Management ReadyTM es una forma en la que los estudiantes pueden adentrarse en la industria de la gestión de proyectos y conectar con esta apasionada comunidad
de profesionales.<br><br>
La certificación PMI Project Management Ready hará que
los estudiantes se introduzcan y familiaricen con los conceptos y el campo de la gestión de proyectos, así como también con las herramientas para aplicar este conocimiento en una amplia gama de trayectorias profesionales. Satisface la necesidad de una certificación reconocida por la industria que permita a las instituciones de educación técnica y profesional agregar valor a sus programas en todos los grupos de carreras.
<hr>
								<br>
								
								<h4>¿POR QUÉ ELEGIR
LA CERTIFICACIÓN PMI PROJECT MANAGEMENT READY?</h4>
								
								
				La certificación PMI Project Management ReadyTM es una nueva forma en la que los estudiantes pueden adentrarse en la industria de la gestión de proyectos e involucrarse con esta apasionada comunidad de profesionales.<br><br>
Es una certificación en gestión de proyectos de nivel básico que
no requiere experiencia laboral previa en gestión de proyectos o que puede no tener las horas educativas mínimas necesarias para rendir
el examen Certified Associate in project management (CAPM)®.
								
							
							
							</div>

                         

                        </div>
                    </div>

                </div>
                <div class="row mt-5">
                    <div class="col-12 text-center">
                        <p class="gca-title-big">CERTIFICADO OFICIAL</p>
                    </div>
                    <div class="col-12 text-center">
                        <img src="../../assets/images/carousel/Sample_Certificate_PMI.png" alt="">
                    </div>
                </div>
            </div>
        </section>
		
		
		<section class="bg-light">
		 <div class="container">
			 
            
			
			 
			 
			 
			 <div class="row">
				
			  <div class="col-md-6">
				  <h4> ¿CUÁLES SON
LOS PRERREQUISITOS?</h4>
Conocimiento sobre:
<ul>
	<li>Conceptos básicos fundamentales sobre la Gestión de Proyectos</li>
	<li>Análisis empresarial</li>
	<li>Metodología Tradicional de Gestión de Proyectos</li>
	<li>Metodología Ágil de Gestión de Proyectos</li>
	<li>Lectura a un nivel de séptimo grado</li>
	<li>Tener conocimientos básicos de informática</li>
	<li>Poder participar en capacitaciones y realizar exámenes	</li>
	
</ul>
				  
 
				 
				 </div>
				
				<div class="col-md-6">
					
					<h4>LA CERTIFICACIÓN PMI PROJECT MANAGEMENT READY ABARCA CUATRO TEMAS PRINCIPALES:</h4>
					
					<ol>
						<li>Fundamentos y conceptos básicos de la Gestión de Proyectos</li>
						<li>Marco teórico del Análisis Empresarial</li>
						<li>Metodologías tradicionales basadas en planes</li>
						<li>Marcos teóricos y metodologías ágiles</li>
						
					
					</ol>

				 
				 
				 </div>

               
            </div>
		 </div>
        </section>
		
		
		
		<section class="p-b-100">
            <div class="container">
                <div class="row align-items-center">
                <div class="col-lg-6">
                        <div class="heading-text heading-section mt-5">
                            <h2>La ruta de certificación</h2>
                            <p><strong>PMI Project Management Ready es una certificación a nivel de "introducción" que no requiere experiencia previa en gestión de proyectos ni un mínimo de horas de aprendizaje para poder tomar el examen "Certified Associate in project management" (CAPM)®.</strong></p>
                            
                        </div>
                    </div>
                    <div class="col-lg-6"> <img alt="" src="../../assets/images/pmi/ruta-pmi.png"> </div>
                    
                </div>
            </div>
        </section>  


        <section class="section-fullwidth text-light p-b-0">
            <div class="row">
                
             

               
            </div>
        </section>

        <!--call-to-action dark -->
        <div class="call-to-action p-t-100 p-b-100  mb-0 call-to-action-dark">
            <div class="container">
                <div class="row">
                    <div class="col-lg-10">
                        <h3>
                            ¿Quieres agregar esta credencial con validez internacional a tu CV?
                        </h3>
                        <p>
                            Conoce todas las soluciones que Global Certification Academy ofrece para agregar VALOR A TU CURRÍCULUM.
                        </p>
                    </div>
                    <div class="col-lg-2"><router-link class="btn btn-primary btn-lg" to="/register">INSCRIBIRME</router-link></div>
                </div>
            </div>
        </div>
        <!--end: call-to-action dark -->


        <LeadComponent></LeadComponent>
        <footer-landing-component></footer-landing-component>
    </div>
</template>

<script>
  import HeaderLandingComponent from "../../components/Landing/HeaderLandingComponent.vue"
  import FooterLandingComponent from "../../components/Landing/FooterLandingComponent.vue"
  import LeadComponent from "../../components/Landing/LeadComponent.vue"
	export default {
		components: {
			HeaderLandingComponent,
            FooterLandingComponent,
            LeadComponent
		},            
		name: 'pmi',
		data() {
			return {
            }
        },
		methods: {
        },
		mounted() {
        }        
    }

</script>